import { render, staticRenderFns } from "./marketingMyorder.vue?vue&type=template&id=bf3473f0&scoped=true"
import script from "./marketingMyorder.vue?vue&type=script&lang=js"
export * from "./marketingMyorder.vue?vue&type=script&lang=js"
import style0 from "./marketingMyorder.vue?vue&type=style&index=0&id=bf3473f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3473f0",
  null
  
)

export default component.exports